<template>
    <div>
        <p class="product-name font-medium truncate">
        <p class="product-name font-medium truncate " :style="{ color: getStatusColor(params), textTransform:capitalize}">
            {{ getDeviceName(params) }}
        </p>
        </p>
    </div>
</template>

<script>
export default {
    computed: {
        capitalize(){
            return "capitalize"
        },
        getStatusColor() {
            return (params) => {

                const STATUS = params.data.sync_status.toLowerCase();
                if (STATUS == "fault" || STATUS == "failed" || STATUS.startsWith("fault")) return "rgb(238,153,34)";
                else if (STATUS == "syncing") return "rgb(190 190 190)";
                else if (STATUS == "synced") return "rgb(0 251 0)";
                else if (STATUS == "notsynced" || STATUS == "unsynced") return "rgb(166 18 60)";
                else if (STATUS.startsWith("syncing")) return "rgb(190 190 190)";
                return "rgb(0 251 0)"
            };
        },
        getDeviceName() {
            return (params) => {
                const STATUS = params.data.sync_status.toLowerCase()
                if (STATUS == "fault" || STATUS == "failed" || params.value.startsWith("Fault")) return `${params.value.charAt(0).toUpperCase()}${params.value.slice(1)}`;
                else if (STATUS.startsWith("syncing")){ 
                    return `${params.value} ${ STATUS === "syncing" ? " "+ params.data.sync_progress + "%":""}`}
                else if (STATUS == "synced") return "Synced";
                else if (STATUS == "unsynced" || STATUS == "notsynced") return "Unsynced";
                return params.data.sync_status
            };
        },
    }
}
</script>